import { Show } from "solid-js";
import { useI18n } from "./i18n";

export function StepActions(props: {
  onBack?: () => void;
  onNext: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  backLabel?: string;
}) {
  const t = useI18n();

  return (
    <div class="flex items-center gap-3 pt-2">
      <Show when={props.onBack}>
        {(back) => (
          <button
            type="button"
            class="rounded-full border border-brand-subtle px-4 py-2.5 text-sm font-medium text-typography-primary transition-colors hover:bg-brand-light active:scale-[0.98]"
            onClick={back()}
          >
            {props.backLabel ?? t("back")}
          </button>
        )}
      </Show>
      <button
        type="button"
        class="ml-auto rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-all brand-button-bg hover:brand-button-bg-active active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50"
        disabled={props.nextDisabled}
        onClick={() => props.onNext()}
      >
        {props.nextLabel ?? t("continue")}
      </button>
    </div>
  );
}
